const EXPANDED_TOGGLE_BUTTON = 'category_navigation.toggle_button.expanded';
const COLLAPSED_TOGGLE_BUTTON = 'category_navigation.toggle_button.collapsed';

export {
  EXPANDED_TOGGLE_BUTTON,
  COLLAPSED_TOGGLE_BUTTON,
};
